import { useLocation } from "react-router-dom";

const noSidebarPaths: string[] = ["/Login"];

const HideSidebar = (): boolean => {
  const location = useLocation();
  return noSidebarPaths.includes(location.pathname);
};

export default HideSidebar;